<template>
  <div>
    <StudyEditHistoryModal
      :show-modal="showConceptModal || showFragranceModal || showDetailsModal"
      :study-edit-history="studyEditHistory"
      @close="() => hideHistoryModal()"
    />
    <div v-if="ready" class="container-fluid">
      <AddTagPopup
        ref="tag-popup"
        :title="addTagPopup.title"
        :data="addTagPopup.data"
      ></AddTagPopup>
      <Breadcrumb
        :values="{
          Home: '/',
          Search: '/search',
          [metadata.study_info.c_mi_number.value]: '',
        }"
      ></Breadcrumb>
      <DetailsCard
        :data="metadata"
        @error="handleSaveError"
        @update="[getStudyDetails(id), getStudyTags()]"
        :coherency-fails="coherencyFails"
        @incoherent-data="(data) => (coherencyFails = data)"
        @showDetailsModal="() => showHistoryModal('showDetailsModal')"
      />
      <div
        class="card"
        id="fragrance"
        style="border: 0; background-color: #f9fafb"
      >
        <div class="card-body" style="padding: 0">
          <div class="table-header">
            <div class="table-title">Fragrance Details</div>
            <div class="table-edit-toggle">
              <el-button
                v-if="userPermissions.isAdmin"
                @click="addNewRow('fragrances')"
                style="
                  width: 150px;
                  height: 29px;
                  margin-top: 0;
                  padding: 0;
                  border-radius: 4px;
                "
                type="primary"
                ><i class="el-icon-plus"></i
                ><span style="margin-left: 5px">Add new fragrance</span></el-button
              >
            </div>
            <div class="table-edit-toggle">
              <el-button
                v-if="editStatus.fragrances.active && userPermissions.isAdmin"
                @click="() => showHistoryModal('showFragranceModal')"
                style="
                  width: 150px;
                  height: 29px;
                  margin-top: 0;
                  padding: 0;
                  border-radius: 4px;
                "
                class="mr-2"
                type="primary"
              >
                <span class="ml-1 mr-2">Changes History</span>
              </el-button>
              <ToggleButton
                v-if="userPermissions.isAdmin"
                class="toggle-switch"
                :width="26"
                :height="14"
                :sync="true"
                @change="(event) => handleSwitchChange(event, 'fragrances')"
                :disabled="
                  (!fragrance_details || !fragrance_details.length) &&
                  !editStatus.fragrances.active
                "
                :color="{ checked: '#78BB95', unchecked: '#4B4B4B' }"
                v-model="editStatus.fragrances.active"
              >
              </ToggleButton>
              <div
                v-if="userPermissions.isAdmin"
                class="edit-label"
                :class="{ active: editStatus.fragrances.active }"
              >
                Edit fragrances
              </div>
            </div>
          </div>
          <el-table
            :data="
              editStatus.fragrances.active
                ? editStatus.fragrances.formData
                : fragrance_details
            "
            :border="true"
            :resizable="true"
            :cell-style="cell_style"
            :header-cell-style="header_cell_style"
            :row-style="row_style"
            :key="`fragrance-table${
              editStatus.fragrances.finished ? '' : '-editable'
            }`"
            v-if="
              editStatus.fragrances.active
                ? true
                : fragrance_details
                ? true
                : false
            "
          >
            <el-table-column
              v-for="(col, idx) in fragranceTableColumns"
              :key="`${col}-fragrance-${idx}`"
              :prop="col"
              :label="fieldsDefinitions.fields[col].label"
              :formatter="col === 'code' ? formatCode : format_ui"
              :style="`min-width: ${col === 'id' ? 50 : 150}px`"
            >
              <template #default="props">
                <div
                  v-if="
                    !(
                      editStatus.fragrances.active &&
                      fieldsDefinitions.fields[col].editable
                    )
                  "
                >
                  {{ format_ui(props.row, props.column, props.row[col]) }}
                </div>
                <el-input
                  v-else-if="fieldsDefinitions.fields[col].type !== 'categorical'"
                  v-model="editStatus.fragrances.formData[props.$index][col]"
                  :type="
                    fieldsDefinitions.fields[col].type === 'int'
                      ? 'number'
                      : 'text'
                  "
                  :placeholder="fieldsDefinitions.fields[col].label"
                  class="cmi-input data-input"
                />
                <el-select
                  v-else
                  v-model="editStatus.fragrances.formData[props.$index][col]"
                  class="w-100"
                  :popper-class="
                    col === 'fragrance_code' ? 'disable-dropdown' : ''
                  "
                  :placeholder="fieldsDefinitions.fields[col].label"
                  filterable
                  clearable
                  :multiple="fieldsDefinitions.fields[col].multivalue"
                  :allow-create="col === 'fragrance_code'"
                  :default-first-option="col === 'fragrance_code'"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in getOptionsForSelectedTag('fragrances', col)"
                      :key="`${value}-${props.$index}`"
                      :label="value"
                      :value="value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="Fragrance Level %" :formatter="format_ui">
              <template #default="props">
                {{ props.row.level ? `${props.row.level}%` : "" }}
                {{
                  props.row.supplemental_info
                    ? ` ${props.row.level ? "+" : ""} ${
                        props.row.supplemental_info
                      }`
                    : ""
                }}
                {{ !props.row.level && !props.row.supplemental_info ? "—" : "" }}
              </template>
            </el-table-column>
            <el-table-column label="Fragrance" align="center">
              <el-table-column
                v-for="(col, idx) in fragranceFamilyTableColumns"
                :key="`${col}-fragrance-${idx}`"
                :prop="col"
                :label="fieldsDefinitions.fields[col].label"
                :formatter="format_ui"
                style="min-width: 150px"
              >
                <template #default="props">
                  <el-select
                    class="w-100"
                    v-if="editStatus.fragrances.active"
                    v-model="editStatus.fragrances.formData[props.$index][col]"
                    :placeholder="fieldsDefinitions.fields[col].label"
                    filterable
                    clearable
                    :multiple="fieldsDefinitions.fields[col].multivalue"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                        v-for="value in getOptionsForSelectedTag(
                          'fragrances',
                          col
                        )"
                        :key="`${value}-${props.$index}`"
                        :label="value"
                        :value="value"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <div v-else>
                    {{ format_ui(props.row, props.column, props.row[col]) }}
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Dominant note" align="center">
              <el-table-column
                v-for="(col, idx) in fragranceNotesTableColumns"
                :key="`${col}-fragrance-${idx}`"
                :prop="col"
                :label="fieldsDefinitions.fields[col].label"
                :formatter="format_ui"
                style="min-width: 150px"
              >
                <template #default="props">
                  <el-input
                    v-if="editStatus.fragrances.active"
                    v-model="editStatus.fragrances.formData[props.$index][col]"
                    :type="
                      fieldsDefinitions.fields[col].type === 'int'
                        ? 'number'
                        : 'text'
                    "
                    :placeholder="fieldsDefinitions.fields[col].label"
                    class="cmi-input data-input"
                  />
                  <div v-else>
                    {{ format_ui(props.row, props.column, props.row[col]) }}
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column v-if="editStatus.fragrances.active" width="70">
              <template #default="props"
                ><el-button
                  @click="deleteRow(props.$index, 'fragrances')"
                  style="
                    width: 50px;
                    height: 29px;
                    margin-top: 0;
                    padding: 0;
                    border-radius: 4px;
                  "
                  type="primary"
                  ><i class="el-icon-delete"></i></el-button
              ></template>
            </el-table-column>
          </el-table>
          <div class="col-12 d-flex justify-content-end align-items-center">
            <el-button
              v-if="editStatus.fragrances.active"
              @click="reverseChanges('fragrances')"
              style="
                width: 200px;
                height: 29px;
                margin-top: 0;
                padding: 0;
                border-radius: 4px;
              "
              type="primary"
              ><i class="el-icon-refresh-left"></i
              ><span style="margin-left: 5">Reverse changes</span></el-button
            >
          </div>
          <p v-if="!fragrance_details">No fragrance details</p>
        </div>
      </div>
      <div
        class="card"
        id="concepts"
        style="border: 0; background-color: #f9fafb"
      >
        <div class="card-body" style="padding: 0">
          <div class="table-header">
            <div class="table-title">Concepts</div>
            <div class="table-edit-toggle">
              <el-button
                v-if="userPermissions.isAdmin"
                @click="addNewRow('concepts')"
                style="
                  width: 150px;
                  height: 29px;
                  margin-top: 0;
                  padding: 0;
                  border-radius: 4px;
                "
                type="primary"
                ><i class="el-icon-plus"></i
                ><span style="margin-left: 5">Add new concept</span></el-button
              >
            </div>
            <div class="table-edit-toggle">
              <el-button
                v-if="editStatus.concepts.active && userPermissions.isAdmin"
                @click="() => showHistoryModal('showConceptModal')"
                style="
                  width: 150px;
                  height: 29px;
                  margin-top: 0;
                  padding: 0;
                  border-radius: 4px;
                "
                class="mr-2"
                type="primary"
              >
                <span class="ml-1 mr-2">Changes History</span>
              </el-button>
              <ToggleButton
                v-if="userPermissions.isAdmin"
                class="toggle-switch"
                :width="26"
                :height="14"
                :sync="true"
                @change="(event) => handleSwitchChange(event, 'concepts')"
                :disabled="
                  (!concepts || !concepts.length) && !editStatus.concepts.active
                "
                :color="{ checked: '#78BB95', unchecked: '#4B4B4B' }"
                v-model="editStatus.concepts.active"
              >
              </ToggleButton>
              <div
                v-if="userPermissions.isAdmin"
                class="edit-label"
                :class="{ active: editStatus.concepts.active }"
              >
                Edit concepts
              </div>
            </div>
          </div>
          <el-table
            :data="
              editStatus.concepts.active ? editStatus.concepts.formData : concepts
            "
            :border="true"
            :resizable="true"
            :cell-style="cell_style"
            :header-cell-style="header_cell_style"
            :row-style="row_style"
            :key="`concept-table${
              editStatus.concepts.finished ? '' : '-editable'
            }`"
            v-if="editStatus.concepts.active ? true : concepts ? true : false"
          >
            <el-table-column
              v-for="col in conceptTableColumns"
              :key="`${col}-concept${
                editStatus.fragrances.finished ? '' : '-editable'
              }`"
              :prop="col"
              :label="fieldsDefinitions.fields[col].label"
              :formatter="format_ui"
            >
              <template #default="props">
                <div
                  v-if="
                    !(
                      editStatus.concepts.active &&
                      fieldsDefinitions.fields[col].editable
                    )
                  "
                >
                  {{ format_ui(props.row, props.column, props.row[col]) }}
                </div>
                <el-input
                  v-else-if="fieldsDefinitions.fields[col].type !== 'categorical'"
                  v-model="editStatus.concepts.formData[props.$index][col]"
                  :type="
                    fieldsDefinitions.fields[col].type === 'int'
                      ? 'number'
                      : 'text'
                  "
                  :placeholder="fieldsDefinitions.fields[col].label"
                  class="cmi-input data-input"
                />
                <el-select
                  v-else
                  v-model="editStatus.concepts.formData[props.$index][col]"
                  class="w-100"
                  :popper-class="col === 'concept_code' ? 'disable-dropdown' : ''"
                  :placeholder="fieldsDefinitions.fields[col].label"
                  filterable
                  clearable
                  :multiple="fieldsDefinitions.fields[col].multivalue"
                  :allow-create="col === 'concept_code'"
                  :default-first-option="col === 'concept_code'"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in getOptionsForSelectedTag('concepts', col)"
                      :key="`${value}-concept-${props.$index}`"
                      :label="value"
                      :value="value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column v-if="editStatus.concepts.active" width="70">
              <template #default="props"
                ><el-button
                  @click="deleteRow(props.$index, 'concepts')"
                  style="
                    width: 50px;
                    height: 29px;
                    margin-top: 0;
                    padding: 0;
                    border-radius: 4px;
                  "
                  type="primary"
                  ><i class="el-icon-delete"></i></el-button
              ></template>
            </el-table-column>
          </el-table>
          <div class="col-12 d-flex justify-content-end align-items-center">
            <el-button
              v-if="editStatus.concepts.active"
              @click="reverseChanges('concepts')"
              style="
                width: 200px;
                height: 29px;
                margin-top: 0;
                padding: 0;
                border-radius: 4px;
              "
              type="primary"
              ><i class="el-icon-refresh-left"></i
              ><span style="margin-left: 5">Reverse changes</span></el-button
            >
          </div>
          <p v-if="!concepts">No concept details</p>
        </div>
      </div>
      <RelatedFilesList
        :data="categories"
        :study-id="id"
        id="files"
      ></RelatedFilesList>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddTagPopup from '../components/StudyDetails/AddTagPopup'
import Breadcrumb from '../components/shared/Breadcrumb'
import detailsIcons from '../constants/detailsIcons'
import generalActions from '../store/modules/general/actionTypes'
import studyActions from '../store/modules/studies/actionTypes'
import studyGetters from '../store/modules/studies/getterTypes'
import RelatedFilesList from '../components/StudyDetails/RelatedFilesList'
import globalAlertMixin from '../mixins/globalAlert'
import DetailsCard from '../components/StudyDetails/DetailsCard'
import generalGetters from '../store/modules/general/getterTypes'
import ToggleButton from '@/components/shared/ToggleButton'
import _ from 'lodash'
import StudyEditHistoryModal from '../components/StudyDetails/StudyEditHistoryModal'

export default {
  name: 'StudyDetails',
  components: {
    DetailsCard,
    RelatedFilesList,
    Breadcrumb,
    AddTagPopup,
    ToggleButton,
    StudyEditHistoryModal
  },
  mixins: [globalAlertMixin],
  data () {
    return {
      id: null,
      categories: [],
      ready: false,
      isInEditMode: false,
      project_name: '',
      addTagPopup: {
        data: [],
        title: ''
      },
      editStatus: {
        fragrances: {
          active: false,
          finished: true,
          formData: [],
          originalData: []
        },
        concepts: {
          active: false,
          finished: true,
          formData: [],
          originalData: []
        }
      },
      conceptTableColumns: ['id', 'concept_code', 'region', 'country', 'name'],
      fragranceFamilyTableColumns: ['family', 'subfamily', 'specifier'],
      fragranceNotesTableColumns: [
        'dominant_note_1',
        'dominant_note_2',
        'dominant_note_3',
        'dominant_note_4',
        'dominant_note_5'
      ],
      fragranceTableColumns: [
        'id',
        'ref_number',
        'code',
        'fragrance_code',
        'methodology',
        'perfumer_name',
        'region',
        'country',
        'name'
      ],
      coherencyFails: [],
      text_tags: ['objective_and_action_standards', 'base', 'panel_profile'],
      studyEditHistory: [],
      showFragranceModal: false,
      showConceptModal: false,
      showDetailsModal: false,
      fileContainerWidth: 0,
      mappedStudyHistory: [],
      multiselectFields: ['region']
    }
  },
  computed: {
    ...mapGetters({
      metadata: studyGetters.GET_STUDY_DETAILS_METADATA,
      studyError: studyGetters.GET_STUDY_ERROR,
      fragrance_details: studyGetters.GET_STUDY_DETAILS_FRAGRANCE_DETAILS,
      concepts: studyGetters.GET_STUDY_DETAILS_CONCEPTS,
      conceptsTags: studyGetters.GET_CONCEPTS_TAGS,
      fragrancesTags: studyGetters.GET_FRAGRANCES_TAGS,
      userPermissions: generalGetters.GET_PERMISSIONS,
      fieldsDefinitions: generalGetters.GET_FIELDS_DEFINITIONS
    })
  },
  watch: {
    categories () {
      this.$nextTick().then(() => {
        this.fileContainerWidth = this.calculateFileWidth()
      })
    }
  },
  methods: {
    ...mapActions({
      studyEditHistoryFetch: studyActions.FETCH_STUDY_EDIT_HISTORY,
      toggleLoading: generalActions.TOGGLE_LOADING,
      getStudyFiles: studyActions.FETCH_STUDY_FILES,
      getStudyFile: studyActions.FETCH_FILE,
      getStudyDetails: studyActions.FETCH_STUDY_DETAILS,
      getQuestions: studyActions.FETCH_QUESTIONS,
      clearQuestions: studyActions.CLEAR_QUESTIONS,
      getStudyTags: studyActions.FETCH_STUDY_TAGS,
      editTag: studyActions.POST_TAG_EDIT,
      updateFragrances: studyActions.SET_FRAGRANCES,
      updateConcepts: studyActions.SET_CONCEPTS
    }),
    hideHistoryModal () {
      this.showConceptModal = false
      this.showFragranceModal = false
      this.showDetailsModal = false
    },
    showHistoryModal (field) {
      const mappedStudyHistory = []
      let editHistoryType = ''
      if (field === 'showConceptModal') editHistoryType = 'concepts'
      if (field === 'showFragranceModal') editHistoryType = 'fragrances'
      if (field === 'showDetailsModal') editHistoryType = 'study'
      this.study_history.forEach((studyHistory, id) => {
        if (studyHistory.type === editHistoryType) {
          studyHistory.changes.forEach((change) => {
            mappedStudyHistory.push({
              id: id + 1,
              user_email: studyHistory.user_email,
              change_date: studyHistory.change_date,
              field: change.field,
              old_value: change.old_value,
              new_value: change.new_value
            })
          })
        }
      })
      this.studyEditHistory = mappedStudyHistory
      this[field] = !this[field]
    },
    row_style (row) {
      if (row.rowIndex % 2) {
        return { 'background-color': '#FAFAFB' }
      }
    },
    formatDisplayedData (data) {
      let DisplayedData = JSON.parse(JSON.stringify(data))
      for (let d in data) {
        DisplayedData[d]['value'] = this.format_meta(data[d]['value'])
      }
      return DisplayedData
    },
    filteredDetails (details) {
      let formatMeta = this.format_meta
      return Object.keys(details).reduce(function (r, e) {
        if (formatMeta(details[e].value) !== '') {
          r[e] = details[e]
        }
        return r
      }, {})
    },
    getOptionsForSelectedTag (type, tag) {
      let selectedTag
      if (type === 'concepts') {
        selectedTag = this.conceptsTags.find(el => el.field === tag)
      } else {
        selectedTag = this.fragrancesTags.find(el => el.field === tag)
      }
      return selectedTag ? selectedTag.options : []
    },
    calculateFileWidth () {
      const components = this.$refs.file_container
      let widths = []
      if (components && components.length) {
        components.forEach(component => {
          widths.push(component.clientWidth)
        })
      }
      return Math.max(...widths, 0)
    },
    getDetailIcon (tag) {
      return detailsIcons[tag]
    },
    checkIfNoTagData (categoryData) {
      return Object.keys(categoryData).some(
        element => categoryData[element].value
      )
    },
    handleSaveError (response) {
      console.log(response)
    },
    convertStringIntoArrayOfStrings (value) {
      if (typeof value === 'string') {
        if (value.includes(',')) return value.split(',')
        else return [value]
      } else if (Array.isArray(value)) {
        return value
      }
    },
    async handleSwitchChange ({ value }, type) {
      if (!value) {
        await this.saveEdit(type)
      } else {
        this.editStatus[type].originalData = _.cloneDeep(
          type === 'concepts' ? this.concepts : this.fragrance_details
        )
        this.editStatus[type].formData = _.cloneDeep(
          type === 'concepts' ? this.concepts : this.fragrance_details
        )

        this.multiselectFields.forEach(key => {
          this.editStatus[type].formData.forEach(obj => {
            if (key in obj && obj[key]) {
              obj[key] = this.convertStringIntoArrayOfStrings(obj[key])
            }
          })
        })
      }
      this.editStatus[type].finished = !this.editStatus[type].finished
    },
    findChanges (data, fields) {
      const changes = []
      if (data.formData.length === data.originalData.length) {
        data.formData.forEach((formData, index) => {
          fields.forEach(field => {
            if (!_.isEqual(formData[field], data.originalData[index][field])) {
              changes.push({
                field,
                'old_value': formData[field],
                'new_value': data.originalData[index][field]
              })
            }
          })
        })
      }
      return changes
    },
    async saveEdit (type) {
      this.toggleLoading(true)
      this.editStatus[type].active = false
      const requestData = {}
      let changes = []
      const conceptFields = [
        'concept_code',
        'country',
        'name',
        'region'
      ]
      const fragnencesFields = [
        'specifier', 'dominant_note_4', 'ref_number',
        'dominant_note_5', 'country', 'dominant_note_2',
        'dominant_note_3', 'code', 'level',
        'dominant_note_1', 'subfamily', 'fragrance_code',
        'perfumer_name', 'supplemental_info', 'name',
        'family', 'region', 'methodology'
      ]
      if (type === 'concepts') {
        if (this.editStatus.concepts.formData.length > 0) {
          requestData.concepts = this.editStatus.concepts.formData
          requestData.concepts.forEach(el => {
            delete el.id
          })
          changes = this.findChanges(this.editStatus.concepts, conceptFields)
        } else {
          requestData.clear_concepts = true
        }
      } else {
        if (this.editStatus.fragrances.formData.length > 0) {
          requestData.perfume_characteristics = this.editStatus.fragrances.formData
          requestData.perfume_characteristics.forEach(el => {
            delete el.id
          })
          changes = this.findChanges(this.editStatus.fragrances, fragnencesFields)
        } else {
          requestData.clear_perfume_characteristics = true
        }
      }
      requestData.changes = changes
      requestData.type = type === 'concepts' ? type : 'fragrances'
      const res = await this.editTag({
        studyId: this.$route.params.id,
        data: requestData
      })
      let options
      if (!res) {
        this.editStatus[type].formData = this.editStatus[type].originalData
        options = {
          duration: 5000,
          title: 'Failed!',
          message:
            'There was an issue with your request, please try again later.',
          type: 'error'
        }
      } else if (res.status === 400) {
        if (res.data && res.data.incoherent_fields) {
          let incoherentFields = []
          Object.keys(res.data.incoherent_fields).forEach(el => {
            if (
              res.data.incoherent_fields[el] &&
              res.data.incoherent_fields[el].length
            ) {
              incoherentFields.push(el)
            }
          })
          options = {
            duration: 5000,
            title: 'Failed!',
            message: `${res.data.message}. Bad fields: ${incoherentFields.join(
              ', '
            )}`,
            type: 'error'
          }
          this.coherencyFails = incoherentFields
        } else {
          this.$emit('error', res)
          options = {
            duration: 5000,
            title: 'Failed!',
            message:
              'There was an issue with your request, please try again later.',
            type: 'error'
          }
        }
      } else {
        if (type === 'fragrances') {
          this.updateFragrances(requestData.perfume_characteristics)
        } else {
          this.updateConcepts(requestData.concepts)
        }
        this.$emit('error', res)
        options = {
          duration: 5000,
          title: 'Success!',
          message: 'Study data was updated successfully.',
          type: 'success'
        }
      }
      this.launchAlert(options)
      this.toggleLoading(false)
      window.location.reload()
    },
    fillInputs (data, type) {
      data[type === 'fragrances' ? 'perfume_characteristics' : type].forEach(
        (val, idx) => {
          this.$set(this.editStatus[type].originalData, idx, val)
          this.$set(this.editStatus[type].formData, idx, val)
        }
      )
    },
    showAddTagPopup (category) {
      let parsedData = {}
      switch (category) {
        case 'geography':
          parsedData = Object.keys(this.metadata.geography).filter(
            el => this.format_meta(this.metadata.geography[el].value) === ''
          )
          this.addTagPopup.data = parsedData.map(key => {
            return {
              label: this.metadata.geography[key].label,
              key: key,
              type: this.metadata.geography[key].type
            }
          })
          this.addTagPopup.title = 'Add geographical info'
          break
        case 'categorization':
          parsedData = Object.keys(this.metadata.product_categorization).filter(
            el =>
              this.format_meta(
                this.metadata.product_categorization[el].value
              ) === ''
          )
          this.addTagPopup.data = parsedData.map(key => {
            return {
              label: this.metadata.product_categorization[key].label,
              key: key,
              type: this.metadata.product_categorization[key].type
            }
          })
          this.addTagPopup.title = 'Add categorization info'
          break
        case 'metadata':
          const sourceData = {
            ...this.metadata.methodological_details_1,
            ...this.metadata.methodological_details_2,
            ...this.metadata.methodological_details_3,
            ...this.metadata.methodological_details_4
          }
          parsedData = Object.keys(sourceData).filter(
            el =>
              this.format_meta(sourceData[el].value) === '' &&
              !Object.keys(this.metadata.methodological_details_2).includes(el)
          )
          this.addTagPopup.data = parsedData.map(key => {
            return {
              label: sourceData[key].label,
              key: key,
              type: sourceData[key].type
            }
          })
          this.addTagPopup.title = 'Add methodology info'
          break
      }
      this.$refs['tag-popup'].showPopup()
    },
    cell_style () {
      return {
        'text-align': 'center',
        'letter-spacing': 0,
        color: '#000000CC',
        'font-family': "'Open Sans', sans-serif",
        'font-size': '14px',
        'line-height': '24px',
        'border-top': 0,
        'border-bottom': 0,
        'word-break': 'normal',
        'overflow-break': 'normal',
        'vertical-align': 'top'
      }
    },
    header_cell_style () {
      return {
        'text-align': 'center',
        'word-break': 'normal',
        'overflow-break': 'normal',
        'letter-spacing': 0,
        color: '#000000CC',
        'text-transform': 'uppercase',
        'font-family': "'Open Sans', sans-serif",
        'font-size': '10px',
        'line-height': '20px',
        'background-color': '#F9FAFB'
      }
    },
    set_fields (index) {
      return this.metadata_fields[index]
    },
    set_width (key) {
      if (key === 'lab_due_date') {
        return '17'
      }
      if (key === 'application') {
        return '16.5'
      }
      if (key === 'base') {
        return '20.5'
      }
      if (key === 'base_type') {
        return '13'
      }
      if (key === 'color_match') {
        return '33'
      }
    },
    format_ui (row, column, string, index) {
      if (typeof string === 'number') {
        return string
      } else if (
        string === null ||
        !string ||
        !string.length ||
        string === 'No Tag'
      ) {
        return '—'
      } else if (Array.isArray(string)) {
        return string.join(', ')
      } else if (typeof string === 'string') {
        return string && string.charAt(0).toUpperCase() + string.slice(1)
      } else {
        return string
      }
    },
    formatCode (row, column, data, index) {
      if (data === null || !data || data === 'No Tag') {
        return '—'
      } else if (Array.isArray(data)) {
        return !data.length ? '—' : data.join(', ')
      } else {
        return data
      }
    },
    format_meta (data) {
      return data === null || !data || data === 'No Tag' ? '' : data
    },
    addNewRow (type) {
      this.editStatus[type].active = true
      this.editStatus[type].formData = [{}, ...this.editStatus[type].formData]
    },
    deleteRow (index, type) {
      this.editStatus[type].formData.splice(index, 1)
    },
    reverseChanges (type) {
      this.editStatus[type].active = false
      this.editStatus[type].formData = this.editStatus[type].originalData
    }
  },

  async mounted () {
    this.toggleLoading(true)
    this.id = this.$route.params.id
    this.study_history = await this.studyEditHistoryFetch(this.id)
    await this.getStudyDetails(this.id)
    await this.getStudyTags()
    await this.clearQuestions()
    await this.getQuestions(this.id)
    this.categories = await this.getStudyFiles(this.id)
    this.ready = true
    this.toggleLoading(false)
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables";

.file-separator {
  margin: 5px 0;
}

.file-container {
  padding: 0;
  margin: 5px 10px;
  max-height: 63px;
  overflow-y: scroll;
}

.file-container a {
  font-size: 10px;
}

.category-name {
  font-size: 13px;
}

.main-category {
  font-size: 17px;
}

.file-count {
  font-size: 11px;
}

.edition-toggle > .vue-js-switch {
  margin: 0;
}

.table-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 70px;

  .table-title {
    width: 290px;
    height: 47px;
    margin-left: 34px;
    margin-top: 11px;
    font-family: "Open Sans", sans-serif;
    font-size: 35px;
    line-height: 47px;
    letter-spacing: 0;
    color: #999999;
  }

  .table-edit-toggle {
    margin: auto 20px auto;
    height: 32px;
    width: 250px;
    display: flex;
    justify-content: center;
    align-items: center;

    .toggle-switch {
      margin: 0 10px 0 0;
    }

    .edit-label {
      font-family: "Source Sans Pro", sans-serif;
      font-size: 14px;
      line-height: 18px;
      color: #4b4b4b;
      transition: color 0.2s linear;

      &.active {
        color: #78bb95;
      }
    }
  }
}
</style>
<style lang="scss">
.disable-dropdown {
  display: none !important;
}
</style>
